
const HistoryEventBox = ({ time, event }) => {

  const labelForEventType = (type) => {
    switch(type) {
      case 'download_pdf':
        return 'Téléchargement PDF'
      case 'download_docx':
        return 'Téléchargement DOCX'
      case 'signature_request_vialink':
        return 'Demande de signature Vialink'
      case 'email_share':
        return 'Partage par email'
      case 'lre_sent':
        return 'LRE envoyée'
      case 'validation_request':
        return 'Création d’une tâche de validation'
      case 'validation_validate':
        return 'Validation acceptée'
      case 'validation_refuse':
        return 'Refus de validation'
      case 'validation_cancel':
        return 'Annulation de la tâche'
      default:
        return `Type d'événement inconnu: ${type}`
    }
  }

  const authorLabel = () => {
    if(event.type === 'validation_request') {
      return `Validateurs désignés : ${event?.validators?.map((user) => `${user.firstname} ${user.lastname}`).join(', ')}`
    }
    return `${event?.author?.firstname} ${event?.author?.lastname}`
  }

  let content = (
    <div className="history-box-v2">
      <header>
        <div className='history-box-v2__dot' />
        <div className="history-box-v2__time">{time}</div>
        <div className="history-box-v2__progress">
          <p className="main">{labelForEventType(event.type)}</p>
          <p className="number-of-entries">{authorLabel()}</p>
          {event?.type === 'validation_refuse' && event?.comment && <p className="comment mt-1">{event.comment}</p>}
        </div>
      </header>
    </div>
  )

  return content
}

export default HistoryEventBox
